<template>
  <div class="teacher-bg">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div class="box">
      <div class="tab-view">
        <router-link to="/work" active-class="u-link--Active1">
          <div class="tab work">工&nbsp;作</div>
        </router-link>
        <!-- <router-link to="/my-class" active-class="u-link--Active2">
          <div class="tab clip">精彩剪辑</div>
        </router-link> -->
        <router-link to="/teacher-info" active-class="u-link--Active3">
          <div class="tab my">我&nbsp;的</div>
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>
  export default{
    name: 'teacher-main',
    created() {
      this.$store.dispatch('getAllSchools');
    },
    methods: {},
    data() {
      return {};
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .teacher-bg {
    @include bg-img('../assets/img/common/Bg');
    width: 100%;
    .box{
      margin-top: 25%;
      display: flex;
      width: 100%;
      justify-content: center;

        .tab-view {
        flex-direction: row;
        font-size: px2rem(0);
        // position: absolute;
        width: px2rem(440);
        // height: px2rem(71);
        // bottom: px2rem(150);
        // left: px2rem(155);
        border-radius: px2rem(32);
        background-color: white;

        .work {
          width: px2rem(220);
          height: px2rem(71);
          @include bg-img('../assets/img/teacher/work_unselect');
        }

        // .clip {
        //   width: px2rem(232);
        //   height: px2rem(70);
        //   @include bg-img('../assets/img/teacher/clip_unselect');
        // }

        .my {
          width: px2rem(217);
          height: px2rem(70);
          @include bg-img('../assets/img/teacher/myself_unselect');
        }

        a {
          display: inline-block;
          text-align: center;
          &.u-link--Active1 {
            .work {

              width: px2rem(220);
              height: px2rem(71);
              @include bg-img('../assets/img/teacher/work');
              @include text-shadow(.5, .5, rgba(137, 64, 0, 0.75));
            }
          }

          // &.u-link--Active2 {
          //   .clip {
          //     width: px2rem(232);
          //     height: px2rem(71);
          //     @include bg-img('../assets/img/teacher/clip');
          //     @include text-shadow(.5, .5, rgba(137, 64, 0, 0.75));
          //   }
          // }

          &.u-link--Active3 {
            .my {
              @include bg-img('../assets/img/teacher/myself');
              width: px2rem(217);
              height: px2rem(70);
              @include text-shadow(.5, .5, rgba(137, 64, 0, 0.75));
            }
          }

          .tab {
            font-family: 'FZKTJT';
            color: white;
            font-size: px2rem(42);
            @include text-shadow(.5, .5, rgba(101, 93, 84, 0.75));
            line-height: px2rem(66);
          }
        }
      }
    }
    
  }


</style>



// WEBPACK FOOTER //
// TeacherMain.vue?17ef53bc